<template>
    <div class="main-container customer-details-page">
        <page-header
            title="환자 정보 상세보기"
            :sub-title="`환자 정보 상세 보기 내용이 들어갑니다`"
        />
        <a-row style="height: calc(100% - 80px); gap: 30px; overflow-x: auto; flex-wrap:nowrap;">
            <a-col style="height: 100%; width: calc(50% - 15px); min-width: 520px;">
                <div class="white-box">
                    <div class="white-box__header">
                        환자정보
                    </div>
                    <div class="white-box__body">
                        <row-with-label
                            label-title="이름"
                            :isRequired="true"
                            :has-error="false"
                        >
                            <a-input v-model:value="customerInfo.name" placeholder="이름" />
                        </row-with-label>
                        <row-with-label
                            label-title="연락처"
                            :isRequired="true"
                            :has-error="false"
                        >
                            <a-input maxLength="13" @input="acceptNumber" v-model:value="customerInfo.mobile" placeholder="휴대전화번호" />
                        </row-with-label>
                        <row-with-label
                            label-title="생년월일"
                            :isRequired="false"
                            :has-error="false"
                        >
                            <a-date-picker @change="handleBirthday" v-model:value="customerInfo.birth" :placeholder="`생년월일`"/>
                        </row-with-label>
                        <row-with-label
                            label-title="성별"
                            :isRequired="false"
                            :has-error="false"
                        >
                            <gender-select 
                                :gender="customerInfo.gender"
                                @handle-gender-change="handleGenderChange"
                            />
                        </row-with-label>
                        <row-with-label
                            label-title="지갑주소"
                            :isRequired="false"
                            :has-error="false"
                        >
                            <input
                                type="text"
                                class="ant-like-input"
                                style="background-color: rgb(243, 245, 246); width: 100%;"
                                v-model="customerInfo.klipAddress"
                                disabled
                            />
                        </row-with-label>
                        <row-with-label
                            :label-title="`수신 ${certificateText}`"
                            :isRequired="false"
                            :has-error="false"
                            class="input-error-wrap-scroll"
                            style="overflow-y: auto;"
                        >
                            <div class="nft-list">
                                <div 
                                    :id="'issueList' + i"
                                    :ref="`issueList${i}`"
                                    :tabindex="i"
                                    @click="changeNftDetails(i)"
                                    class="nft-item-wrap"
                                    :class="showNftDetailsIndex == i && innerWidth > 1000
                                    ? 'selected' : ''"
                                    v-for="(item, i) in nftList"
                                    :key="i"  
                                >
                                    <div class="nft-image">
                                        <img :src="getImageUrl(item)" />
                                    </div>
                                    <div class="nft-info">
                                        <div class="nft-info-title" v-if="validateIsAvailable(item?.issueStatus)">{{ item?.products?.name }}</div>
                                        <div class="nft-info-title" v-else>{{ generateTitleText(item?.issueStatus) }}</div>
                                        <div v-if="validateIsAvailable(item.issueStatus)" class="nft-info-detail">{{ item?.descText }}</div>
                                    </div>
                                    <div class="right-area">
                                        <!-- <div class="btn-container" v-if="validateIsAvailable(item?.issueStatus)">
                                            <button
                                                class="kakao-icon"
                                                style="background-color: #ffe414;  width: 28px;height: 28px;display: flex;align-items: center;justify-content: center;border: none;border-radius: 100%;"
                                                @click.stop="() => resendNft(item)"
                                            >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 18 18" fill="none">
                                                <path d="M9.0025 1.125C4.03112 1.125 0 4.25326 0 8.10611C0 10.5048 1.56043 12.6186 3.93109 13.8779L2.93081 17.5409C2.84079 17.8657 3.21089 18.1255 3.49597 17.9356L7.87219 15.0323C8.24229 15.0672 8.61739 15.0872 8.9975 15.0872C13.9689 15.0872 18 11.959 18 8.10611C18 4.25326 13.9739 1.125 9.0025 1.125Z" fill="#2F3337"/>
                                            </svg>
                                            </button>
                                        </div> -->
                                        <div 
                                            class="nft-arrow"
                                            :class="showNftDetailsIndex === i && innerWidth > 1000
                                            ? 'selected' : ''"
                                            v-if="item?.issueStatus != WarrantyStatusEnum.DISPOSED && item?.issueStatus != WarrantyStatusEnum.RETURNED"
                                        >
                                            <a-dropdown trigger="click" @click.stop>
                                                <template #overlay>
                                                <a-menu>
                                                    <a-menu-item @click.stop="recallNft(item?._id, i)">
                                                    회수
                                                    </a-menu-item>
                                                    <a-menu-item @click.stop="disposeNft(item?._id, i)">
                                                    삭제
                                                    </a-menu-item>
                                                </a-menu>
                                                </template>
                                                <a-button style="width:32px;padding-inline-start: 0; padding-inline-end: 0;">
                                                    <MoreOutlined />
                                                </a-button>
                                            </a-dropdown>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>`
                        </row-with-label>
                    </div>
                    <div class="white-box__footer">
                        <a-button class="delete-button" @click="deleteCustomer">환자 삭제</a-button>
                        <a-button class="cancle-button" v-if="window.history.length>1" @click="$router.go(-1)">취소</a-button>
                        <a-button class="cancle-button" v-else @click="window.location.href=window.opener.location.href">취소</a-button>
                        <a-button class="submit-button" @click="updateCustomerInfo">저장</a-button>
                    </div>
                </div>
            </a-col>
            <a-col style="height: 100%; width: calc(50% - 15px); min-width: 500px;" v-if="showNftDetailsData">
                <div class="white-box">
                    <div class="white-box__header">
                        인증서 상세설정
                    </div>
                    <div class="white-box__body" style="overflow-y: auto;" >
                        <a-row>
                            <a-col :span="6">
                                <div class="preview-image">
                                    <img :src="getImageUrl(showNftDetailsData)" />
                                </div>
                                <a-row @click="previewCertification = true" style="color: #00000099; text-decoration: underline; justify-content: center; padding-right: 15px; cursor: pointer; margin-top: 5px;">상세보기</a-row>
                            </a-col>
                            <a-col :span="18" class="certification-info-col">
                                <row-with-label
                                    label-title="인증서명"
                                    :isRequired="false"
                                    :has-error="false"
                                    :labelWidth="120"
                                >
                                    <input
                                        type="text"
                                        class="ant-like-input"
                                        style="background-color: rgb(243, 245, 246); width: 100%;"
                                        v-model="showNftDetailsData.products.name"
                                        disabled
                                    />
                                </row-with-label>
                                <row-with-label
                                    label-title="발행병원"
                                    :isRequired="false"
                                    :has-error="false"
                                    :labelWidth="120"
                                >
                                    <input
                                        type="text"
                                        class="ant-like-input"
                                        style="background-color: rgb(243, 245, 246); width: 100%;"
                                        v-model="showNftDetailsData.companyName"
                                        disabled
                                    />
                                </row-with-label>
                                <row-with-label
                                    label-title="시술 일자"
                                    :isRequired="false"
                                    :has-error="false"
                                    :labelWidth="120"
                                >
                                    <input
                                        type="text"
                                        class="ant-like-input"
                                        style="background-color: rgb(243, 245, 246); width: 100%;"
                                        :value="dayjs(showNftDetailsData.surgeryAt).format('YYYY-MM-DD')"
                                        disabled
                                    />
                                </row-with-label>
                                <row-with-label
                                    label-title="교정 종료 예상일"
                                    :isRequired="false"
                                    :has-error="false"
                                    :labelWidth="120"
                                    v-if="showNftDetailsData.deliveryOptions&& showNftDetailsData.deliveryOptions.surgeryEndAt"
                                >
                                    <a-date-picker :allowClear="false" :disabledDate="disabledBeforeToday" @change="handleSurgeryEndAt" v-model:value="showNftDetailsData.deliveryOptions.surgeryEndAt" :placeholder="`생년월일`"/>
                                </row-with-label>
                            </a-col>
                        </a-row>
                        <a-row class="grey-box" v-if="showNftDetailsData.deliveryOptions">
                            <a-row>
                                <a-col :span="8">
                                    교정 진척도
                                </a-col>
                                <a-col :span="16">
                                    {{totalDeliveryCount}}회차 / ∞
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="8">
                                    교정 시작일
                                </a-col>
                                <a-col :span="16">
                                    {{dayjs(showNftDetailsData.surgeryAt).format('YYYY-MM-DD')}} ( {{dateOfSurgeryFromToday}}일 지남 )
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="8">
                                    교정 종료 예정일
                                </a-col>
                                <a-col :span="16">
                                    {{showNftDetailsData.deliveryOptions.surgeryEndAt?showNftDetailsData.deliveryOptions.surgeryEndAt.format('YYYY-MM-DD'):''}} ( {{daysLeftUntilSurgeryEndAtFromToday}}일 남음 )
                                </a-col>
                            </a-row>
                        </a-row>
                        <row-with-label
                            label-title="발송 템플릿"
                            :isRequired="false"
                            :has-error="false"
                            v-if="showNftDetailsData.deliveryOptions"
                            
                        >
                        <!-- showNftDetailsData.subCampaignId -->
                            <a-button @click="previewAlimtalk = true" style="background: white; border: 1px solid #D1D6DB; width: 180px; display: inline-flex; margin-right: 10px;">투명교정기 교체 알림</a-button>
                            <!-- <button
                                class="kakao-icon"
                                style="background-color: #ffe414;  width: 28px;height: 28px;display: inline-flex;align-items: center;justify-content: center;border: none;border-radius: 100%; padding: 0;"
                                @click.stop="sendTheCurrentNftClaraAlimtalk"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 18 18" fill="none">
                                    <path d="M9.0025 1.125C4.03112 1.125 0 4.25326 0 8.10611C0 10.5048 1.56043 12.6186 3.93109 13.8779L2.93081 17.5409C2.84079 17.8657 3.21089 18.1255 3.49597 17.9356L7.87219 15.0323C8.24229 15.0672 8.61739 15.0872 8.9975 15.0872C13.9689 15.0872 18 11.959 18 8.10611C18 4.25326 13.9739 1.125 9.0025 1.125Z" fill="#2F3337"/>
                                </svg>
                            </button> -->
                        </row-with-label>
                        <row-with-label
                            label-title="발송 주기"
                            :isRequired="true"
                            :has-error="false"
                            v-if="showNftDetailsData.deliveryOptions"
                        >
                            <a-row align="middle">
                                <a-date-picker :allowClear="false" :disabledDate="disabledBeforeToday" @change="handleDeliveryDate" v-model:value="deliveryDate" disabled :placeholder="`발송 주기`" style="width: 180px;"/>
                                <span style="margin-left: 10px;">기준으로</span>
                            </a-row>
                        </row-with-label>
                        <row-with-label
                            :label-title="parseInt(index)+1"
                            :isRequired="false"
                            :has-error="false"
                            v-if="showNftDetailsData.deliveryOptions"
                            v-for="(currentSendCycle, index) in showNftDetailsData.deliveryOptions.afterDeliveryInfo"
                            labelClass="label-align-right"
                        >
                            <a-row align="middle">
                                <a-input-number :disabled="currentSendCycle.currentDeliveryCount" v-model:value="currentSendCycle.afterDeliveryDay" :min="1" style="width: 55px;"/>
                                <span style="margin: 0 10px;">일 주기로</span>
                                <a-input-number :disabled="!currentSendCycle.isNewData && (currentSendCycle.currentDeliveryCount == currentSendCycle.originalAfterDeliveryCount)" v-model:value="currentSendCycle.afterDeliveryCount" :min="currentSendCycle.currentDeliveryCount?currentSendCycle.currentDeliveryCount:1" style="width: 55px;"/>
                                <span style="margin: 0 10px;">회 발송</span>
                                <CloseOutlined v-show="!currentSendCycle.currentDeliveryCount" @click="deleteSendCycle(index)"/>
                            </a-row>
                        </row-with-label>
                        <row-with-label
                            label-title=""
                            :isRequired="false"
                            :has-error="false"
                            v-if="showNftDetailsData.deliveryOptions"
                        >
                            <a-row align="middle" justify="center" >
                                <a-button @click="addSendCycle" style="background: white; border: 1px solid #00000033;"> 
                                    <PlusOutlined/>
                                    <span>알림추가</span>
                                </a-button>
                            </a-row>
                        </row-with-label>
                        <row-with-label
                            label-title=""
                            :isRequired="false"
                            :has-error="false"
                            v-if="showNftDetailsData.deliveryOptions&&showNftDetailsData.deliveryOptions.afterDeliveryInfo&&showNftDetailsData.deliveryOptions.afterDeliveryInfo.length >= 1"
                        >
                            <a-row align="middle" justify="center" style="height: 40px; font-family: 'SuitRegular'; font-weight: 600;">
                                {{ nextDeliveryDate?`다음 알림톡은 ${nextDeliveryDate.date.format('YYYY-MM-DD ( dd )')} 오전 9시에 발송됩니다.`:'' }}
                                
                            </a-row>
                        </row-with-label>
                        <row-with-label
                            label-title="발송 예정일"
                            :isRequired="false"
                            :has-error="false"
                            v-if="showNftDetailsData.deliveryOptions"
                        >
                            <div class="grey-box" style="display: flex; flex-direction: column; gap: 5px;">
                                <div v-for="(currentDateData,index) in deliveryHistory" :key="index" >
                                    <div v-if="currentDateData.badge" :class="['badge-icon',currentDateData.badge]" :style="index == 0 ? 'margin-top:0;' : ''">
                                        {{ currentDateData.badge == 'sent' ? '발송완료' : (currentDateData.badge == 'book' ? '예약됨' :'')}}
                                    </div>
                                    <div v-if="currentDateData && currentDateData.date">
                                        {{currentDateData.date.format('YYYY-MM-DD ( dd )')}}
                                    </div>
                                </div>
                            </div>
                        </row-with-label>
                    </div>
                    <div class="white-box__footer" v-show="showNftDetailsData.deliveryOptions&& showNftDetailsData.deliveryOptions.surgeryEndAt">
                        <a-button class="cancle-button" v-if="window.history.length>1" @click="$router.go(-1)">취소</a-button>
                        <a-button class="cancle-button" v-else @click="window.location.href=window.opener.location.href">취소</a-button>
                        <a-button class="submit-button" @click="updateDeliveryOptions">저장</a-button>
                    </div>
                </div>
            </a-col>
        </a-row>
        <a-modal v-model:open="previewAlimtalk" title="" footer="" class="clara-alimtalk-preview">
            <div class="alimktalk-header">
                <img src="@/assets/img/clara-alimtalk-top.png" alt="" srcset="">
            </div>
            <div class="alimktalk-body">
                <div class="row-flex">
                    <span class="label-text">병원명</span>
                    <span class="content-text">{{ showNftDetailsData.companyName }}</span>
                </div>
                <div class="row-flex">
                    <span class="label-text">수술일자</span>
                    <span class="content-text">{{ dayjs(showNftDetailsData.surgeryAt).format('YYYY-MM-DD') }}</span>
                </div>
                <div class="row-flex">
                    <span class="label-text">수술명</span>
                    <span class="content-text">{{ showNftDetailsData.products.name }}</span>
                </div>
                <div class="row-flex">
                    <div class="content">
                        {{customerInfo.name}}님,<br>
                        오늘은 교정기를 교체하는 날이에요.<br>
                        잊지말고 투명교정기를 교체해주세요.<br>
                        <br>
                        ▼ 아래 버튼을 클릭하여 교체방법을 알아보세요.
                    </div>
                </div>
                <div class="row-flex">
                    <a-button>투명교정기 교체방법</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal v-model:open="previewCertification" title="" footer="" class="certification-prewview">
            <div 
                class="preview-container-frame"
                ref="previewContainerFrame"
                :style="previewContainerStyle"  
            >
                <div class="preview-image">
                    <img :src="getImageUrl(showNftDetailsData)" />
                </div>
                <div class="preview-detail-container">
                    <em/>
                    <div class="preview-detail-header">
                        <div class="preview-detail-title" v-if="validateIsAvailable(showNftDetailsData?.issueStatus)">
                        {{ showNftDetailsData?.products?.name }}
                        </div>
                        <div v-else>
                        {{ generateTitleText(showNftDetailsData?.issueStatus) }}
                        </div>
                        <div 
                            class="preview-detail-desc" 
                            v-if="hasProductDetails && validateIsAvailable(showNftDetailsData?.issueStatus)" 
                            v-html="productDescription" 
                            :class="previewCertificationShowMoreisOpen ? 'is-open' : 'is-closed'"  
                        />
                        <div class="preview-detail-desc">
                            {{ generateTitleText(showNftDetailsData?.issueStatus) }}
                        </div>
                        <p
                            v-if="!previewCertificationShowMoreisOpen"
                            @click="showMore"
                            class="show-more"
                        >
                            더 보기
                        </p>
                    </div>
                    <div class="division-bar" />
                    <div 
                        class="preview-attributes-container"
                        v-if="hasProductAttributes && validateIsAvailable(showNftDetailsData?.issueStatus)"
                    >
                        <div 
                            class="preview-attribute-wrap"
                            v-for="(item, i) in showNftDetailsData?.products?.attributes"
                            :key="i"
                        >
                            <div class="preview-attributes-title">{{ item?.trait_type }}</div>
                            <div class="preview-attributes-content">{{ item?.value }}</div>
                        </div>
                    </div>
                    <div class="division-bar" />
                    <div class="preview-attributes-container">
                        <div class="preview-attribute-wrap">
                            <div class="preview-attributes-title">발행 시각</div>
                            <div class="preview-attributes-content">{{ convertDateTime(showNftDetailsData.originalCreateAt )}}</div>
                        </div>
                        <div class="preview-attribute-wrap">
                            <div class="preview-attributes-title">보낸 사람</div>
                            <div class="preview-attributes-content">자체 발행</div>
                        </div>
                        <div class="preview-attribute-wrap">
                            <div class="preview-attributes-title">트랜잭션 해시</div>
                            <button class="transaction-hash copy-button" @click="copyText">
                                0x341a2b....c3d4e5
                                <div class="copy-hash">
                                    <i class="fa-regular fa-copy" />
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { 
    MedicalDept,
    WarrantyStatusEnum,
    WarrantyImgUrlEnum,
    YnEnum,
    OphCompanies,
 } from '@/enums/common.enums';
import { 
  CertifiedCompanies,
  SurfaceCompanies,
} from '@/enums/dent.enums';
import {
    phoneNumberFormatter,
    convertDate,
    convertDateTime,
    oneBtnDialog,
    twoBtnDialog,
    twoBtnHtmlDialog,
    getValueByTraitType,
    convertDeptText,
} from '@/utils/utils';
import PageHeader from '@/views/components/PageHeader.vue';
import RowWithLabel from '@/views/components/RowWithLabel';
import GenderSelect from '@/views/IssueCertificate/components/GenderSelect';

import dayjs from 'dayjs';
require('dayjs/locale/ko'); // 한국어 요일을 표시하고 싶다면 한국어 로케일을 불러옵니다.
dayjs.locale('ko'); // 로케일을 설정합니다.
import {
    PlusOutlined,
    CloseOutlined,
    MoreOutlined
} from '@ant-design/icons-vue';
export default {
    components: {
        PageHeader,
        RowWithLabel,
        GenderSelect,
        PlusOutlined,
        CloseOutlined,
        MoreOutlined
    },
    data() {
        return {
            window,
            WarrantyStatusEnum,
            dayjs,
            paginationData: {
                rowsPerPage: 10,
                currentPage: 1,
                totalPages: 0,
            },
            customerInfo:{
                name:'',
                mobile:'',
                birth:'',
                gender:'',
                klipAddress:'',
            },
            
            medicalDept: [],
            MedicalDept,
            certificateText: this.isZeiss ? this.$i18n.t('common_certificatetext_oph') : this.$i18n.t('common_certificatetext_dent'),
            nftList: [],
            showNftDetailsData:null,
            deliveryDate : dayjs(),
            totalDeliveryCount:0,
            dateOfSurgeryFromToday: 0,
            daysLeftUntilSurgeryEndAtFromToday:0, //교정 종료 예정일
            showNftDetailsIndex: 0,
            innerWidth: window.innerWidth,
            dentPrevTeethArray:[],
            previewAlimtalk:false,
            previewCertification:false,
            previewCertificationShowMoreisOpen: false, 
            stopAjax :false,
        };
    },
    async mounted() {
        await this.getMedicalDept();
        await this.fetchData();
        
        document.querySelector('.input-error-wrap-scroll').addEventListener('touchmove', async () => {
            let scrollTop = document.querySelector('.input-error-wrap-scroll').scrollTop;
            await this.handleScroll();
            this.lastScrollHeight = scrollTop;
        });
        document.querySelector('.input-error-wrap-scroll').addEventListener('scroll', async () => {
            let scrollTop = document.querySelector('.input-error-wrap-scroll').scrollTop;
            await this.handleScroll();
            this.lastScrollHeight = scrollTop;
        });
    },
    computed: {
        previewContainerStyle() {
            if(this.showNftDetailsData?.issueStatus === WarrantyStatusEnum.DISPOSED) {
                return `background-color:${this.defaultColorCode}`;  
            }
            if(this.showNftDetailsData?.issueStatus === WarrantyStatusEnum.RETURNED) {
                return `background-color:${this.defaultColorCode}`;  
            }
            const bgColor = this.showNftDetailsData?.products?.background_color || this.defaultColorCode;
            return `background-color:${bgColor}`;
        },
        hasProductDetails() {
            return this.showNftDetailsData && this.showNftDetailsData?.products;
        },
        
        productDescription() {
            return this.showNftDetailsData?.products?.description;
        },
        nextDeliveryDate() {
            let allArray = [...this.deliveryHistory].reverse();

            return allArray.filter(i=>i.status=='book' || i.status=='new-data')[0] ?? null;
        },
        hasProductAttributes() {
            return this.showNftDetailsData?.products?.attributes;
        },
        deliveryHistory() {
            let allArray = [];

            let plusDateCount = 0;
            this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.map((currentSendCycle,index)=>{
                let dateArray = [];
                for (let i = 1; i < currentSendCycle.afterDeliveryCount+1; i++) {
                    plusDateCount = plusDateCount + currentSendCycle.afterDeliveryDay ;
                    let status = 'error';
                    if(currentSendCycle.currentDeliveryCount == null){
                        status = 'new-data'
                    }else if(i <= currentSendCycle.currentDeliveryCount){
                        status = 'sent';
                    }else if(i <= currentSendCycle.originalAfterDeliveryCount){
                        status = 'book';
                    }else if(i > currentSendCycle.originalAfterDeliveryCount){
                        status = 'new-data';
                    }
                    dateArray.push({
                        date:this.deliveryDate.add(plusDateCount,'days'),
                        status
                    });
                }
                allArray.push(...dateArray)
            })
            let beforeStatus = '';
            let newArray = [];
            allArray.map((i,index)=>{
                if(beforeStatus == ''){
                    beforeStatus = i.status;
                }
                if(
                    (i.status !== beforeStatus)
                    && beforeStatus != 'new-data'
                ){
                    newArray = newArray.filter(i=>i !== beforeStatus);
                    newArray.push({
                        badge:beforeStatus
                    });
                    beforeStatus = i.status;
                }
                newArray.push(i);
                if(
                    (allArray.length-1 == index)
                    && (i.status !== 'new-data')
                ){
                    newArray.push({
                        badge: i.status
                    });
                }
            })

            return [...newArray].reverse() ?? null;
        }
    },
    watch:{
        previewCertification(){
            this.previewCertificationShowMoreisOpen = false;
        },
        showNftDetailsData(){
            if(!this.showNftDetailsData){
                return false;
            }
            if(this.showNftDetailsData.surgeryAt) {
                this.showNftDetailsData.originalCreateAt = this.showNftDetailsData.surgeryAt;
                this.showNftDetailsData.surgeryAtDayjs = dayjs(this.showNftDetailsData.surgeryAt).format('YYYY-MM-DD');
                this.dateOfSurgeryFromToday = dayjs().startOf('day').diff(dayjs(this.showNftDetailsData.surgeryAt).startOf('day'),'day')
            }
            if(this.showNftDetailsData.deliveryOptions ){
                if(this.showNftDetailsData.deliveryOptions.surgeryEndAt){
                    this.showNftDetailsData.deliveryOptions.surgeryEndAt = dayjs(this.showNftDetailsData.deliveryOptions.surgeryEndAt);
                    this.daysLeftUntilSurgeryEndAtFromToday = this.showNftDetailsData.deliveryOptions.surgeryEndAt.startOf('day').diff(dayjs().startOf('day'),'day')
                } 
                if(this.showNftDetailsData.deliveryOptions.afterDeliveryInfo){
                    let totalDeliveryCount = 0;
                    this.showNftDetailsData.deliveryOptions.afterDeliveryInfo = this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.map((currentSendCycle,index)=>{
                        return {
                            ...currentSendCycle,
                            afterDeliveryDay:parseInt(currentSendCycle.afterDeliveryDay),
                            afterDeliveryCount:parseInt(currentSendCycle.afterDeliveryCount),
                            originalAfterDeliveryCount:currentSendCycle.originalAfterDeliveryCount?currentSendCycle.originalAfterDeliveryCount:parseInt(currentSendCycle.afterDeliveryCount)
                        }
                    })
                    this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.map((currentSendCycle,index)=>{
                        if(currentSendCycle.currentDeliveryCount){
                            totalDeliveryCount = totalDeliveryCount + currentSendCycle.currentDeliveryCount;
                        }
                    })
                    this.totalDeliveryCount = totalDeliveryCount;
                } 
                if(this.showNftDetailsData.deliveryOptions.baseAt){
                    this.deliveryDate = dayjs(new Date(this.showNftDetailsData.deliveryOptions.baseAt));
                }
            }
        }
    },
    methods: {
        disabledBeforeToday(current) {
            // 오늘 이전 날짜를 비활성화, 오늘 이후만 선택 가능
            return current && current < new Date().setHours(0, 0, 0, 0);
        },
        async handleScroll(){
            const container = document.querySelector('.input-error-wrap-scroll');
            if (
                (container.scrollTop + container.clientHeight >= container.scrollHeight)
            ) {
                if(this.nftList.length >= 9) {
                    if(this.stopAjax == true){
                        return false;
                    }
                    this.paginationData.currentPage = this.paginationData.currentPage+1;
                    await this.loadNextList();
                }
            }
        },
        showMore() {
            this.previewCertificationShowMoreisOpen = true;
        },
        convertDateTime,
        acceptNumber(){
            if(!this.customerInfo.mobile) return;
            var x = this.customerInfo.mobile.replace(/\D/g, '').match(/(\d{0,3})(\d{0,4})(\d{0,4})/);
            this.customerInfo.mobile = !x[2] ? x[1] :  x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        handleSurgeryEndAt(value){
            this.showNftDetailsData.deliveryOptions.surgeryEndAt = value;
        },
        handleDeliveryDate(value){
            this.deliveryDate = value;
        },
        handleBirthday(value){
            this.customerInfo.birth = value;
        },
        handleGenderChange(gender) {
            this.customerInfo.gender = gender;
        },
        changeNftDetails(i) {
            this.showNftDetailsIndex = i;
            if(this.nftList[i]?.issueStatus != WarrantyStatusEnum.DISPOSED && this.nftList[i]?.issueStatus != WarrantyStatusEnum.RETURNED){
                this.showNftDetailsData = this.nftList[i];
            }else{
                this.showNftDetailsData = null;
            }
        },
        getImageUrl(item) {
            if(item?.issueStatus === WarrantyStatusEnum.DISPOSED) {
                return WarrantyImgUrlEnum.DISPOSED;
            }
            if(item?.issueStatus === WarrantyStatusEnum.RETURNED) {
                return WarrantyImgUrlEnum.RETURNED;
            }
            if(item?.products?.image) {
                return item?.products?.image;
            }
            return this.defaultImageUrl;
        },
        
        validateIsAvailable(message) {
            switch(message) {
                case 'returned':
                    return false;
                case 'disposed':
                    return false;
                case 'request-issued':
                    return true;
                case 'Y':
                    return true;
                case 'N':
                    return true;
                default:
                    return true;
            }
        },
        generateTitleText(issueStatus) {
            switch(issueStatus) {
                case WarrantyStatusEnum.DISPOSED:
                    return `삭제된 ${this.certificateText}입니다`;
                case WarrantyStatusEnum.RETURNED:
                    return `회수된 ${this.certificateText}입니다`;
                default:
                    return '';
            }
        },
        async recallNft(nftId, index) {
            const isConfirmed = await twoBtnDialog(`${this.certificateText} 회수`, `환자에게 보낸 ${this.certificateText}를 회수하시겠습니까? 회수한 ${this.certificateText}는 새로운 내용으로 다시 발행할 수 있습니다.`, '회수');
            if(!isConfirmed) return;
            try {
                this.$store.commit('setIsLoading', true);
                const response = await this.$apiInstance.post(`/nfts/return/${nftId}`);
                if((response.status !== 200 && response.status !== 201)) return;
                this.$store.commit('setIsLoading', false);
                await oneBtnDialog(`${this.certificateText} 회수 완료`, `${this.certificateText} 회수가 완료되었습니다.`, false);
                this.nftList[index].issueMessage = WarrantyStatusEnum.RETURNED;
                this.nftList[index].issueStatus = WarrantyStatusEnum.RETURNED;
                if(this.showNftDetailsData&&this.showNftDetailsData.index == index){
                    this.showNftDetailsData = null;
                }
            } catch(error) {
                console.log(error);
                this.$store.commit('setIsLoading', false);
                await oneBtnDialog(`${this.certificateText} 회수 실패`, `${this.certificateText} 회수에 실패하였습니다.`, false);
            }
        },
        async disposeNft(nftId, index) {
            const isConfirmed = 
                await twoBtnHtmlDialog(
                `${this.certificateText} 삭제`,
                `<p>정말로 ${this.certificateText}를 삭제하시겠습니까? 삭제할 경우, 
                    <span style="color: #e73023;">같은 제품코드로는 다시 발행할 수 없습니다. </span>
                (재발행을 원하신다면 <span style="font-weight: 600;">"회수"</span> 버튼을 클릭하세요.) 
                이 작업은 취소할 수 없습니다.</p>`,
                '삭제'
                );
            if(!isConfirmed) return;
            try {
            this.$store.commit('setIsLoading', true);
            const response = await this.$apiInstance.post(`/nfts/dispose/${nftId}`);
            if((response.status !== 200 && response.status !== 201)) return;
                this.$store.commit('setIsLoading', false);
                await oneBtnDialog(`${this.certificateText} 삭제 완료`, `${this.certificateText} 삭제가 완료되었습니다.`, false);
                this.nftList[index].issueStatus = WarrantyStatusEnum.DISPOSED;
                this.nftList[index].issueMessage = WarrantyStatusEnum.DISPOSED;
                if(this.showNftDetailsData&&this.showNftDetailsData.index == index){
                    this.showNftDetailsData = null;
                }
            } catch(error) {
                console.log(error);
                this.$store.commit('setIsLoading', false);
                await oneBtnDialog(`${this.certificateText} 삭제 실패`, `${this.certificateText} 삭제에 실패하였습니다.`, false);
            }
        },
        async getMedicalDept() {
            this.medicalDept = this.$store.getters.getMedicalDept;
        },
        async loadNextList() {
            const loadMore = true;
            await this.fetchData(loadMore);
        },
        async fetchData(loadMore) {
            this.$store.commit('setIsLoading', true);

            try {
                const obj = {
                    "page": this.paginationData.currentPage,
                    "limit": this.paginationData.rowsPerPage
                };
                const response = await this.$apiInstance.post(`/customers/v3/${this.$route.query.customerId}`,obj);

                if (response && (response.status === 200 || response.status === 201) && response.data) {
                    const customerInfo = response.data.customerInfo;
                    if (customerInfo) {
                        this.customerInfo = {
                            ...customerInfo,
                            birth:customerInfo.birth?dayjs(customerInfo.birth):'',
                        };
                        this.customerInfo.mobile = customerInfo.deleteYn === YnEnum.Y
                            ? customerInfo.mobile
                            : phoneNumberFormatter(customerInfo.mobile);

                        if (customerInfo.deleteYn !== YnEnum.Y && customerInfo.teethNos) {
                            this.dentPrevTeethArray = customerInfo.teethNos;
                        }
                    }

                    if (Array.isArray(response.data.nftList.docs)) {
                        if(loadMore){
                            this.nftList = [...this.nftList, ...response.data.nftList.docs];
                            if(response.data.nftList.docs.length == 0){
                                this.stopAjax = true
                            }
                        }else{
                            this.nftList = response.data.nftList.docs;
                        }
                        let arrayIndex = -1;
                        this.nftList = this.nftList.map(i=>{
                            arrayIndex++;
                            return {
                                ...i,
                                index:arrayIndex
                            }
                        })
                        const newArray = [...this.dentPrevTeethArray];
                        this.nftList.forEach((currentNFT, i) => {
                            if (currentNFT) {
                                currentNFT.issueMessage = currentNFT.issueStatus || currentNFT.issueType;

                                const product = currentNFT.products;
                                if (product && product.group_name) {
                                    currentNFT.products.background_color = 
                                    currentNFT.issueStatus !== 'returned' && currentNFT.issueStatus !== 'disposed' 
                                        ? product.background_color
                                        : this.defaultColorCode;
                                    if(product.group_name === CertifiedCompanies.dentium.name) {
                                        currentNFT.products.background_color = CertifiedCompanies.dentium.colorCode;
                                    } else if(product.group_name === SurfaceCompanies.plasmapp.name) {
                                        currentNFT.products.background_color = SurfaceCompanies.plasmapp.colorCode;
                                    } else if(product.group_name === OphCompanies.zeiss.name) {
                                        currentNFT.products.background_color = OphCompanies.zeiss.colorCode;
                                    }
                                }
                                const teethNo = getValueByTraitType(currentNFT.products?.attributes, '치아번호');
                                if(teethNo) {
                                    newArray.push(parseInt(teethNo))
                                }

                                currentNFT.descText = this.generateDescriptionText(currentNFT);
                            }
                        });

                        if (this.nftList.length > 0) this.changeNftDetails(this.showNftDetailsIndex);
                        const setArray = new Set(newArray);
                        this.dentPrevTeethArray = Array.from(setArray);
                    }
                }
            } catch(error) {
                console.log(error);
                this.$store.commit('setIsLoading', false);
                await oneBtnDialog('가져오기 실패', `${this.certificateText} 내역 가져오기에 실패하였습니다.`);
            } finally {
                this.$store.commit('setIsLoading', false);
            }
        },
        async sendTheCurrentNftClaraAlimtalk() {
            try {
                if(!this.showNftDetailsData){
                    return false;
                }
                let messageContent = `환자에게 투명 교정 교체 알림톡을 다시 보내시겠습니까?`;
                const isConfirmed = await twoBtnHtmlDialog(`투명 교정 교체 알림톡 다시 보내기`, messageContent);
                if(!isConfirmed) return;
                this.$store.commit('setIsLoading', true);
                const response = await this.$apiInstance.post(`/messages/change/clara-ai/${this.showNftDetailsData._id}`);

                this.$store.commit('setIsLoading', false);
                if (response && (response.status === 200 || response.status === 201) && response.data && response.data.status !== 400) {
                    await oneBtnDialog(`투명 교정 교체 알림톡 보내기 완료`, `환자에게 투명 교정 교체 알림톡이 다시 발송되었습니다.`, false);
                }else{
                    console.log(response)
                    await oneBtnDialog(`투명 교정 교체 알림톡 보내기 실패`, response.data.message, false);
                }
            } catch(error) {
                console.log(error);
                this.$store.commit('setIsLoading', false);
                await oneBtnDialog(`투명 교정 교체 알림톡 보내기 실패`, `투명 교정 교체 알림톡 재발송에 실패하였습니다.`, false);
            } finally {
                this.$store.commit('setIsLoading', false);
            }
        },
        generateDescriptionText(nft) {
            // 병원, 시간, 수술부위, 
            let surgeryAreaText = '';
            let hospitalText = '';
            let createAtText = '';
            if(nft) {
                surgeryAreaText = this.getSurgeryPartText(nft);

                // 수술 병원은 attributes에서 찾기
                createAtText = convertDate(nft.surgeryAt);
                // products가 있는 경우, 없는 경우 나누어야 함

                hospitalText = getValueByTraitType(nft.products?.attributes, '병원명');
            }

            let result = `${hospitalText}·${createAtText}·${surgeryAreaText}`;
            if(result.includes('undefined')) result.replace('undefined', '');
            return result;
        },
        getOldSurgeryPartText(object) {
            const nftItem = object.products ? object.products : object;
            const teethNum = getValueByTraitType(nftItem?.attributes, '치아번호');
            if (teethNum) {
                return `${teethNum} 번 치아`;
            }

            if (nftItem?.name?.includes('좌안')) {
                return OphSurgeryPart.LEFT;
            }

            if (nftItem?.name?.includes('우안')) {
                return OphSurgeryPart.RIGHT;
            }

            return '';
        },
        getSurgeryPartText(object) {
            if (!object.surgeryArea) {
                return this.getOldSurgeryPartText(object);
            }
            
            const { productType, dept, value } = object.surgeryArea;
            
            if (dept === MedicalDept.DENT) {
                if(productType && productType === '투명교정') {
                    return value;
                }
                return `${value}번 치아`;
            }
            
            if (dept === MedicalDept.OPH) {
                return value;
            }
            
            return value;
        },
        addSendCycle(){
            this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.push(
                {
                    afterDeliveryDay:10,
                    afterDeliveryCount:3,
                    isNewData:true
                }
            )
        },
        deleteSendCycle(index){
            this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.splice(index,1);
        },
        async updateCustomerInfo(){
            
            const name = this.customerInfo.name;
            const mobile = this.customerInfo.mobile;
            // const birth = this.customerInfo.birth;
            
            if(!name || name.replaceAll(' ','') === '') {
                await oneBtnDialog('환자명 미기입', '환자명을 입력해 주세요.', false);
                return false;
            } 
            if(!mobile) {
                await oneBtnDialog('휴대폰 번호 미기입', '휴대폰 번호를 입력해 주세요.', false);
                return false;
            } 
            if(!mobile.startsWith('01') || mobile.length < 12) {
                await oneBtnDialog('휴대폰 번호 오류', '휴대폰 번호를 올바르게 입력해 주세요.', false);
                return false;
            } 
            // if(!birth || (birth && birth.format('YYYY/MM/DD').length < 10)) {
            //     await oneBtnDialog('생년월일 오류', '생년월일을 올바르게 입력해 주세요.', false);
            //     return false;
            // }

            const obj = {};
            obj.name = this.customerInfo.name;
            obj.mobile = this.customerInfo.mobile.replaceAll('-','');
            obj.birth = this.customerInfo.birth?this.customerInfo.birth.format('YYYY/MM/DD'):'';
            obj.gender = this.customerInfo.gender;

            const isConfirmed = await twoBtnDialog(`환자 정보 수정`, `환자 정보를 수정하시겠습니까?`, '저장');
            if(!isConfirmed) return;
            try {
                const response = await this.$apiInstance.put(`/customers/${this.$route.query.customerId}`,obj);
                if((response.status == 200 || response.status == 201)){
                    await oneBtnDialog('환자 정보 수정 완료', '환자 정보 수정이 완료되었습니다.', true);
                }
            } catch(error) {
                console.log(error);
                await oneBtnDialog('환자정보 수정 실패', '환자정보 수정에 실패했습니다.', false);
            }
        },
        async updateDeliveryOptions(){
            const surgeryEndAt = this.showNftDetailsData.deliveryOptions.surgeryEndAt.format('YYYY-MM-DD');
            
            if(!surgeryEndAt || (surgeryEndAt && surgeryEndAt.length < 10)) {
                await oneBtnDialog('교정 종료 예상일 오류', '교정 종료 예상일을 올바르게 입력해 주세요.', false);
                return false;
            }

            const obj = {};
            obj.surgeryEndAt = surgeryEndAt;
            obj.afterDeliveryInfo = this.showNftDetailsData.deliveryOptions.afterDeliveryInfo.map(i=>{
                if(i.currentDeliveryCount){
                    return {
                        afterDeliveryDay:i.afterDeliveryDay,
                        afterDeliveryCount:i.afterDeliveryCount,
                        currentDeliveryCount:i.currentDeliveryCount,
                    }
                }
                return {
                    afterDeliveryDay:i.afterDeliveryDay,
                    afterDeliveryCount:i.afterDeliveryCount,
                }
            });
            if(obj.afterDeliveryInfo.filter(i=>i.afterDeliveryDay==='' || i.afterDeliveryCount==='')[0]){
                await oneBtnDialog('발송 주기 오류', '발송 주기 입력이 안된값이 있습니다.', false);
                return false;
            }
            let nftId = this.showNftDetailsData._id;
            const isConfirmed = await twoBtnDialog(`발송 주기 수정`, `발송 주기를 수정하시겠습니까?`, '저장');
            if(!isConfirmed) return;
            try {
                const response = await this.$apiInstance.put(`/nfts/delivery/options/${nftId}/${dayjs(this.deliveryDate).startOf('day').format('YYYY-MM-DD')}`,obj);
                if((response.status == 200 || response.status == 201)){
                    await oneBtnDialog('발송 주기 수정 완료', '발송 주기 수정이 완료되었습니다.', true);
                }
            } catch(error) {
                console.log(error);
                await oneBtnDialog('발송 주기 수정 실패', '발송 주기 수정에 실패했습니다.', false);
            }
        },
        async deleteCustomer(){
            try {
                const isConfirmed = await twoBtnHtmlDialog(
                    '환자 삭제',
                    `<p><span style="font-weight: 600;">${this.customerInfo.name}</span> 님을 삭제하시겠습니까? <br/>
                        삭제하더라도 환자에게 발행한 ${this.certificateText} 이력은 발행 내역 조회에 남아있습니다.</p>`,
                    '삭제'
                );
                if (!isConfirmed) return;

                const response = await this.$apiInstance.delete(`/customers/${this.customerInfo._id}`);
                if((response.status !== 200 && response.status !== 201)) return;
                await oneBtnDialog('환자 정보 삭제 완료', '환자 정보 삭제가 완료되었습니다.', false);
                this.$router.push('/customer-list');
            
            } catch(error) {
                console.log(error);
                await oneBtnDialog('환자정보 삭제 실패', '환자정보 삭제에 실패했습니다.', false);
            }
        },
        async resendNft(record) {
            let messageContent = `환자에게 ${this.certificateText} 알림톡을 다시 보내시겠습니까?`;
            if(record.issuanceMethod == "CLARA_ALIMTALK_REGULARLY"){
                messageContent = `환자에게 ${this.certificateText} 알림톡을 다시 보내시겠습니까?<br/>* 투명교정 교체 알림은 ‘${this.certificateText} 상세설정’에서 보내주세요.`;
            }
            const isConfirmed = await twoBtnHtmlDialog(`${this.certificateText} 알림 다시 보내기`, messageContent);
            if(!isConfirmed) return;
            try {
                const response = await this.$apiInstance.post(`/nfts/re-send/bulk/${record.subCampaignId}`);
                if((response.status !== 200 && response.status !== 201)) return;
                    await oneBtnDialog(`${this.certificateText} 알림 보내기 완료`, `환자에게 ${this.certificateText} 알림톡이 다시 발송되었습니다.`, false);
            } catch(error) {
                console.log(error);
                await oneBtnDialog(`${this.certificateText} 알림 보내기 실패`, `${this.certificateText} 알림톡 재발송에 실패하였습니다.`, false);
            }
        },
    },
};
</script>
<style lang="scss">
    @import "@/assets/scss/customer-details.scss";
</style>
<style lang="scss" scoped>
    .teeth-and-margin {
        max-height: 100%;
    }
</style>